{
  "$schema": "https://json-schema.org/draft/2020-12/schema",
  "$id": "file:///AcademicTerm.json",
  "title": "AcademicTerm",
  "type": "object",
  "properties": {
    "Semester": {
      "type": "number"
    },
    "Year": {
      "type": "number"
    }
  }
}
